import { intlPhoneDigits } from './helper';

// Shares the one normalization implementation with the rest of the app (see
// helper.js) — digits exactly as stored, no formatting/rewriting.
export const internationalPhoneDigits = (phone) => intlPhoneDigits(phone);

export const buildWhatsAppInvoiceUrl = (phone, text) => {
    const digits = internationalPhoneDigits(phone);
    const recipientPath = digits ? `/${digits}` : '';
    return `https://wa.me${recipientPath}?text=${encodeURIComponent(text)}`;
};

export const buildViberInvoiceUrl = (phone, text) => {
    const digits = internationalPhoneDigits(phone);
    if (!digits) return `viber://forward?text=${encodeURIComponent(text)}`;

    return `viber://chat/?number=%2B${digits}&draft=${encodeURIComponent(text)}`;
};
